import { getLangName } from '@/constants/ElementPlusLangConfig'
import { PageRoutes } from '@/constants/PageRoutes'
import { useDownloadConfig } from '@/hooks/use-download-config.ts'
import { APP_CONFIG } from '@/project-config'
import classNames from 'classnames'
import { PageRoutes as CloudComputingPowerRoutes } from 'cloud-computing-power/constants/PageRoutes'
import { PageRoutes as DebitCardRoutes } from 'debit-card/constants/PageRoutes'
import { ElCollapse, ElCollapseItem, ElSpace } from 'element-plus'
import { useI18n } from 'i18n-utils'
import { ProjectTheme } from 'platform-config'
import { useBaseInfoStore, useEnvStore, useLanguageStore, useProjectTheme, useUserInfoStore } from 'store'
import {
  ArrowRight,
  CurrencyIcon,
  CustomButton,
  DialogHeader,
  HocElDialog,
  ListCell,
  PhoneDarkThemeIcon,
  PhoneDownloadIcon,
  PhoneLanguageIcon,
  PhoneLightThemeIcon,
  SizedBox,
  ThemeIcon,
  useDialog,
} from 'ui-components'
import { DefineComponentProps } from 'utils'
import { HomeMobileMenuLayout } from './HomeMobileMenu.layout'
import { MobileChangeCurrency } from './MobileChangeCurrency'
import { MobileChangeLanguage } from './MobileChangeLanguage'

interface HomeMobileMenuProps {
  onClose: () => void
}
const DebitCard = import.meta.env.VITE_DEBIT_CARD_MODULE
export const HomeMobileMenu = defineComponent<HomeMobileMenuProps>({
  props: DefineComponentProps<HomeMobileMenuProps>(['onClose']),
  setup(props) {
    const { t } = useI18n()
    const baseInfoStore = useBaseInfoStore()
    const router = useRouter()
    const userInfoStore = useUserInfoStore()
    const languageStore = useLanguageStore()
    const themeStore = useProjectTheme()
    const envStore = useEnvStore()
    const { dialogVisible, openDialog, closeDialog } = useDialog()
    const { onGoToDownloadAndroid, onGoToDownloadIos, onGoToDownloadGooglePlay, onGoToDownloadTestFlight } = useDownloadConfig()
    const { dialogVisible: currencyDialogVisible, openDialog: openCurrencyDialog, closeDialog: closeCurrencyDialog } = useDialog()

    const gotoQuote = () => {
      props.onClose?.()
      router.push(PageRoutes.Quote)
    }

    const gotoSpotTrade = () => {
      props.onClose?.()
      router.push(PageRoutes.SpotTrade)
    }

    const gotoContractTrade = () => {
      props.onClose?.()
      router.push(PageRoutes.ContractTrade)
    }

    const onGotoPage = (route: PageRoutes) => {
      dialogVisible.value = false
      props.onClose?.()
      router.push({
        path: route,
        query: {
          entry: route === PageRoutes.Register ? 'h5_home_popup' : '',
        },
      })
    }

    const currentLanguageName = computed(() => {
      return getLangName(languageStore.currentLanguage)
    })

    /** 联系方式 */
    const contactUs = computed<ApiResponse.ContactUs[]>(() => {
      return envStore.config?.contactUs || []
    })

    const gotoBuyCloud = () => {
      props.onClose?.()
      router.push(CloudComputingPowerRoutes.Cloud)
    }

    const gotoCloudOrder = () => {
      props.onClose?.()
      router.push(CloudComputingPowerRoutes.Order)
    }

    const gotoCloudIncome = () => {
      props.onClose?.()
      router.push(CloudComputingPowerRoutes.Income)
    }

    const gotoCloudCalculator = () => {
      props.onClose?.()
      router.push(CloudComputingPowerRoutes.Calculator)
    }
    const getDebitCardList = () => {
      if (DebitCard) {
        return [
          {
            title: '信用卡',
            path: DebitCardRoutes.DebitIndex,
            children: [
              // { title: '落地页', path: DebitCardRoutes.Home, icon: <CloudComputingPowerIcon /> },
              { title: '卡列表', path: DebitCardRoutes.DebitIndex },
              { title: '卡片', path: DebitCardRoutes.MyCards },
              { title: '卡包', path: DebitCardRoutes.CardPackage },
            ],
          },
        ]
      }

      return []
    }
    const handleMenu = (item: { path: string }) => {
      props.onClose?.()
      router.push(item.path)
    }
    return () => (
      <HomeMobileMenuLayout class="default-container">
        {!userInfoStore.isLogin && (
          <>
            <CustomButton class="register-login login" onClick={() => onGotoPage(PageRoutes.Login)}>
              {t('登录')}
            </CustomButton>
            <CustomButton type="primary" class="register-login" onClick={() => onGotoPage(PageRoutes.Register)}>
              {t('注册')}
            </CustomButton>
            <SizedBox height={16} />
          </>
        )}

        <ListCell title={t('行情')} isArrow onClick={gotoQuote} />
        <ElCollapse>
          <ElCollapseItem title={t('交易')}>
            {{
              default: () => (
                <>
                  <ListCell title={t('现货交易')} onClick={gotoSpotTrade} />
                  <ListCell title={t('U本位合约')} onClick={gotoContractTrade} />
                </>
              ),
              icon: ({ isActive }: { isActive: boolean }) => (
                <span class={classNames('arrow-right-icon', { active: isActive })}>
                  <ArrowRight />
                </span>
              ),
            }}
          </ElCollapseItem>
          {APP_CONFIG.isOpenCloudComputingPower && (
            <ElCollapseItem title={t('云算力')}>
              {{
                default: () => (
                  <>
                    <ListCell title={t('购买算力')} onClick={gotoBuyCloud} />
                    {userInfoStore.isLogin ? (
                      <>
                        {' '}
                        <ListCell title={t('算力订单')} onClick={gotoCloudOrder} />
                        <ListCell title={t('算力收益')} onClick={gotoCloudIncome} />
                      </>
                    ) : null}

                    <ListCell title={t('计算器')} onClick={gotoCloudCalculator} />
                  </>
                ),
                icon: ({ isActive }: { isActive: boolean }) => (
                  <span class={classNames('arrow-right-icon', { active: isActive })}>
                    <ArrowRight />
                  </span>
                ),
              }}
            </ElCollapseItem>
          )}
          {getDebitCardList().map((item) => {
            return (
              <ElCollapseItem title={t(item.title)}>
                {{
                  default: () => (
                    <>
                      {item.children.map((subItem) => {
                        return <ListCell title={t(subItem.title)} onClick={() => handleMenu(subItem)} />
                      })}
                    </>
                  ),
                  icon: ({ isActive }: { isActive: boolean }) => (
                    <span class={classNames('arrow-right-icon', { active: isActive })}>
                      <ArrowRight />
                    </span>
                  ),
                }}
              </ElCollapseItem>
            )
          })}
        </ElCollapse>
        {APP_CONFIG.isOpenInvestFinancial && <ListCell title={t('投资理财')} onClick={() => onGotoPage(PageRoutes.Invest)} />}
        {APP_CONFIG.isCompliant && <ListCell title={t('法律与合规')} isArrow onClick={() => onGotoPage(PageRoutes.LegalCompliance)} />}
        <div class="divider" />
        <ElCollapse>
          <ElCollapseItem>
            {{
              title: () => (
                <ElSpace size={2}>
                  <PhoneDownloadIcon />
                  {t('下载App')}
                </ElSpace>
              ),
              default: () => (
                <>
                  <ListCell title={t('苹果商店下载')} onClick={onGoToDownloadIos} />
                  {envStore.config?.downloadAppInfo?.defultTestFlightUrl || baseInfoStore.webInitInfo?.testFlightUrl ? (
                    <ListCell title={t('TestFlight下载')} onClick={onGoToDownloadTestFlight} />
                  ) : null}
                  <ListCell title={t('谷歌商店下载')} onClick={onGoToDownloadGooglePlay} />
                  <ListCell title={t('APK下载')} onClick={onGoToDownloadAndroid} />
                </>
              ),
              icon: ({ isActive }: { isActive: boolean }) => (
                <span class={classNames('arrow-right-icon', { active: isActive })}>
                  <ArrowRight />
                </span>
              ),
            }}
          </ElCollapseItem>
        </ElCollapse>
        <ListCell prefix={<PhoneLanguageIcon />} title={t(currentLanguageName.value)} isArrow onClick={openDialog} />
        <ListCell prefix={<CurrencyIcon />} title={userInfoStore.currentToCurrency.toUpperCase()} isArrow onClick={openCurrencyDialog} />
        <ListCell
          prefix={<ThemeIcon />}
          title={t('主题')}
          description={
            <div class={'toggle-theme'} onClick={() => themeStore.toggleTheme()}>
              <span class={classNames('toggle-theme-item', { show: themeStore.themeType === ProjectTheme.Light })}>
                <PhoneLightThemeIcon />
              </span>
              <span class={classNames('toggle-theme-item', { show: themeStore.themeType === ProjectTheme.Dark })}>
                <PhoneDarkThemeIcon />
              </span>
            </div>
          }
        />
        <div class="divider" />
        <div class="contact-us">
          {contactUs.value.map((item) => (
            <a href={item.url} target="_blank" rel="noreferrer" key={item.url}>
              <img src={item.src} alt="" />
            </a>
          ))}
        </div>

        <HocElDialog v-model={dialogVisible.value} placement="bottom" closeOnClickModal={false} modal={true} offsetTop={64} showClose={false} onClose={closeDialog} appendToBody>
          {{
            header: () => <DialogHeader onClose={closeDialog}>{t('语言')}</DialogHeader>,
            default: () => <MobileChangeLanguage onLanguageChange={closeDialog} />,
          }}
        </HocElDialog>

        <HocElDialog
          v-model={currencyDialogVisible.value}
          placement="bottom"
          closeOnClickModal={false}
          modal={true}
          offsetTop={64}
          showClose={false}
          onClose={closeCurrencyDialog}
          appendToBody
        >
          {{
            header: () => <DialogHeader onClose={closeCurrencyDialog}>{t('法币')}</DialogHeader>,
            default: () => <MobileChangeCurrency onCurrencyChange={closeCurrencyDialog} />,
          }}
        </HocElDialog>
      </HomeMobileMenuLayout>
    )
  },
})
